import PulseLoader from 'react-spinners/PulseLoader'
import {  useNavigate, useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowAltCircleRight, faFileAlt, faPrint, faSearch } from "@fortawesome/free-solid-svg-icons"
import { useLazyGetStudentReportQuery } from "../reportsApiSlice"
import StudentReportsList from "./StudentReportsList"
import useTitle from '../../../hooks/useTitle'

function StudentReportsListFilter() {
    const {groupId, type} = useParams()
    useTitle('geshtop-Exercise: Reports List')
    const [q,setQ] = useState('')
    const [ trigger,  {
        data:tasks,
        isLoading,
        isSuccess,
        isError,
        error
    } ] = useLazyGetStudentReportQuery()
   
    useEffect(() => {
        if (isSuccess){
         //setSelectedTasks(data.selectedTasks)
        }
    }, [isSuccess])
    useEffect(() => {
        if (groupId!=="0"){
         trigger({groupId})
        }
    }, [])
    
   
   
    const navigate = useNavigate()
    const getGrades =()=>{
        if (!isSuccess){
            trigger({groupId})
        }
    }

    const content =(<>

    <div className="filter-form">
  
       

     {groupId==="0" && <p>יש לבחור קבוצה</p> }  
     {isSuccess && <> <button className="icon-button"  onClick={() => window.print()}><FontAwesomeIcon   icon={faPrint} />  </button> </>}  
     {isSuccess && <> <button className="icon-button"  onClick={() => navigate(`/${type}/${groupId}/`)}><FontAwesomeIcon   icon={faArrowAltCircleRight} />  </button> </>}  

    </div>
    {isSuccess  &&  <StudentReportsList  tasks ={tasks} />}
    {isLoading  && <PulseLoader color={"#FFF"} />}
    {isError  && <p className="errmsg">{error?.data?.message}</p>}
</> 
) 
  
      


  return content;
}

export default StudentReportsListFilter